import { createAsyncThunk } from "@reduxjs/toolkit";
import { getIntroClientList, getClientNoteListForExport } from "../services/agentClientsService";

 export const getIntroClients = createAsyncThunk(
    "agentClients/getIntroClients",
    (requestPayload) => {
      return getIntroClientList(requestPayload);
    }
  );

export const fetchClientNotesForExports = createAsyncThunk(
  "agentClients/fetchClientNotesForExports",
  (requestPayload) => {
    return getClientNoteListForExport(requestPayload);
  }
);